const generatePath = <Root extends string, SubLink extends string>(
  root: Root,
  sublink: SubLink,
) => {
  return `${root}${sublink}` as const;
};

const HUB_ROOT = '/hub';
const REPLEN_ROOT = '/replenishment';
const REORDER_ROOT = '/reorder';
const INSIGHTS_ROOT = '/insights';
const REBALANCING_ROOT = '/rebalancing';
const ASSORTMENT_ROOT = '/assortment';
const EVENTS_ROOT = '/events';
const BUYING_ROOT = '/buying';

export const HUB_PATH_APP = {
  root: generatePath(HUB_ROOT, '/modules'),
  parameters: generatePath(HUB_ROOT, '/parameters'),
  settings: generatePath(HUB_ROOT, '/settings'),
  userManagement: generatePath(HUB_ROOT, '/user-management'),
};

export const REPLEN_PATH_APP = {
  overview: generatePath(REPLEN_ROOT, '/overview'),
};
export const REORDER_PATH_APP = {
  overview: generatePath(REORDER_ROOT, '/overview'),
};
export const INSIGHTS_PATH_APP = {
  root: generatePath(INSIGHTS_ROOT, '/retail'),
  bestsellers: generatePath(INSIGHTS_ROOT, '/bestsellers'),
  explorer: generatePath(INSIGHTS_ROOT, '/explorer'),
  overview: generatePath(INSIGHTS_ROOT, '/overview'),
  thoughtspot: generatePath(INSIGHTS_ROOT, '/thoughtspot'),
};
export const REBALANCING_PATH_APP = {
  overview: generatePath(REBALANCING_ROOT, '/overview'),
};
export const ASSORTMENT_PATH_APP = {
  inSeason: generatePath(ASSORTMENT_ROOT, '/in-season'),
};
export const EVENTS_PATH_APP = {
  home: generatePath(EVENTS_ROOT, '/home'),
};
export const BUYING_PATH_APP = {
  overview: generatePath(BUYING_ROOT, '/overview'),
};
